import ServerSettings, {ServerSettingsFieldType} from "../../../gd/settings/server-settings/server-settings"

const fieldsConfig = {
    createTask : {
        type            : ServerSettingsFieldType.OPTION,
        defaultValue    : true,
        options         : [true, false]
    },
    createProject : {
        type            : ServerSettingsFieldType.OPTION,
        defaultValue    : false,
        options         : [true, false]
    },

    eventsView : {
        type            : ServerSettingsFieldType.OPTION,
        defaultValue    : true,
        options         : [true, false]
    },
}

export default class ProjectAccessLimitedSettings extends ServerSettings {

    public createTask           : boolean
    public createProject        : boolean
    public eventsView           : boolean

    constructor(config:any) {

        super(config, fieldsConfig)

        this.createTask             = this.initValue('createTask')
        this.createProject          = this.initValue('createProject')
        this.eventsView             = this.initValue('eventsView')
    }

    toJson() {
        const result = {}

        this.valueToJson(result, 'createTask')
        this.valueToJson(result, 'createProject')
        this.valueToJson(result, 'eventsView')

        return result
    }
}